import { Link } from "react-router-dom";
import { citedFile, documentOpenPath } from "../pages/documentViewFlow";
import { fileName } from "../lib/words";

/**
 * A cited source. A web source opens in a new tab. A local notice is a `file://` path a browser
 * will not open, so it links to the document view at its page instead.
 */
export function SourceLink({ url, pkg = null }: { url: string; pkg?: string | null }) {
  const local = citedFile(url);
  if (local) {
    const to = documentOpenPath({ path: local.path, pkg, page: local.page });
    return (
      <Link to={to ?? "/documents"} className="mono" style={{ wordBreak: "break-all" }} title="Open in the document view">
        {fileName(local.path)}{local.page ? `, page ${local.page}` : ""}
      </Link>
    );
  }
  if (/^https?:\/\//.test(url)) {
    return (
      <a href={url} target="_blank" rel="noreferrer" className="mono" style={{ wordBreak: "break-all" }}>
        {url}
      </a>
    );
  }
  return <span className="mono muted" style={{ wordBreak: "break-all" }}>{url || "no source recorded"}</span>;
}
